import * as React from 'react';

import { CollectionsModule } from '@coursera-web/cds-labs';

import { formatNumber } from 'bundles/enterprise-ui/utils';
import type { ConsumerPathwayRolePageDataContextType } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRolePageDataContext';
import { useRoleRelatedDegrees } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRoleRelatedDegreeCollectionContext';
import { getRelatedDegreeCollectionMetadataByRoleSlug } from 'bundles/unified-career-academy/utils/getRelatedDegreeCollectionMetadataByRoleSlug';

import _t from 'i18n!nls/career-academy';

type Props = {
  pageData: ConsumerPathwayRolePageDataContextType;
};

export const RelatedDegreesModuleRenderer = ({ pageData }: Props) => {
  const { relatedDegrees, relatedDegreesLoading } = useRoleRelatedDegrees() || {};

  const collectionMetadata = getRelatedDegreeCollectionMetadataByRoleSlug(pageData?.careerRoleData?.slug);

  if (!relatedDegrees || !collectionMetadata) {
    return null;
  }

  return (
    <div data-testid="related-degrees-module">
      <CollectionsModule
        removeTopPadding
        layout="text-top/image-bottom"
        headline={_t('Advance your career with a flexible degree')}
        description={_t(
          "#{percentageOfBachelorJobPosting}% of job listings for #{jobRole} require a bachelor's degree, while #{percentageOfMasterJobPosting}% require a master's. Stand out from other applicants by earning your degree from a world-class institution.",
          {
            percentageOfBachelorJobPosting: formatNumber(Math.ceil(collectionMetadata.percentageOfBachelorJobPosting)),
            percentageOfMasterJobPosting: formatNumber(Math.ceil(collectionMetadata.percentageOfMasterJobPosting)),
            jobRole: pageData?.careerRoleData?.name,
          }
        )}
        collections={relatedDegrees ? [relatedDegrees] : undefined}
        isCollectionsLoading={relatedDegreesLoading}
        lazyLoadImage
      />
    </div>
  );
};
